<br>
<div class="a-w1-column">
    <form [formGroup]="group" class="a-w1-column">
        <div class="a-w1-row">
            <p-floatlabel variant="on" class="a-w5">
                <input formControlName="descripcion" pInputText type="text" class="w-full" pSize="small" />
                <label for="descripcion">Descripción Contrato</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="a-w5">
                <p-select id="via" [options]="via" appendTo="body" filterBy="nombre" [showClear]="true"
                    formControlName="via" styleClass="w-full" inputId="float-label" [showClear]="true"
                    (onChange)="onChangePortByVia($event)" size="small" />
                <label for="via">Via</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="a-w5">
                <p-multiSelect id="pais" [options]="paises" appendTo="body" filterBy="nombre" [showClear]="true"
                    formControlName="pais" styleClass="w-full" inputId="float-label" [showClear]="true"
                    optionLabel="nombre" [virtualScroll]="true" (onChange)="onChangePortByPais()" size="small" />
                <label for="pais">Pais Origen</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="a-w5">
                <p-multiSelect id="origen" [options]="puertosOrigen" appendTo="body" filterBy="nombre"
                    [showClear]="true" formControlName="origen" styleClass="w-full text-xs" inputId="float-label"
                    [showClear]="true" optionLabel="nombre" [virtualScroll]="true" size="small" optionValue="codigo" />
                <label for="origen">Puerto Origen</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="a-w5">
                <p-multiSelect id="destino" [options]="puertosDestino" appendTo="body" filterBy="nombre"
                    [showClear]="true" formControlName="destino" styleClass="w-full text-xs" inputId="destino"
                    [showClear]="true" optionLabel="nombre" optionLabel="nombre" optionValue="codigo" size="small"
                    [virtualScroll]="true" />
                <label for="destino">Puerto Destino</label>
            </p-floatlabel>
        </div>

        <div class="a-w1-row">
            <p-floatlabel variant="on" class="a-w5">
                <p-select id="transportista" [options]="transportistas" appendTo="body" filterBy="nombre"
                    [showClear]="true" formControlName="transportista" styleClass="w-full text-xs"
                    inputId="transportista" [showClear]="true" optionLabel="nombre" class="text-xs" size="small"
                    optionValue="codigo" [filter]="true" filterBy="nombre" [virtualScroll]="true" />
                <label for="transportista">Transportista</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="a-w5">
                <input formControlName="numero" pInputText type="text" class="w-full" pSize="small" />
                <label for="numero">Número Contrato</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="a-w5">
                <p-datepicker id="desde" formControlName="desde" showIcon iconDisplay="input" styleClass="w-full"
                    inputStyleClass="w-full text-xs" dateFormat="dd/mm/yy" appendTo="body" size="small" />
                <label for="desde">F. Desde</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="a-w5">
                <p-datepicker id="hasta" formControlName="hasta" showIcon iconDisplay="input" styleClass="w-full"
                    inputStyleClass="w-full text-xs" dateFormat="dd/mm/yy" appendTo="body" size="small" />
                <label for="hasta">F. Hasta</label>
            </p-floatlabel>
            <div class="a-w5 a-w1-row">
                <p-floatlabel variant="on" class="a-w2">
                    <p-select id="estado" [options]="Estados" appendTo="body" formControlName="estado"
                        styleClass="w-full text-xs" class="text-xs" size="small" />
                    <label for="hasta">Estado</label>
                </p-floatlabel>
                <p-button icon="pi pi-search" label="Buscar" (onClick)="search()" styleClass="p-button-sm"></p-button>
                <p-button icon="pi pi-download" label="Exportar" (onClick)="export()" styleClass="p-button-sm"></p-button>
            </div>
            <!-- <span style="display: flex; align-items: center; gap: 10%;">
                <p-checkbox formControlName="activo" value="true" inputId="ny" [binary]="true"
                    inputId="activo"></p-checkbox>
                <label for="activo">Activo</label>
            </span>
            <p-button icon="pi pi-search" label="Buscar" (onClick)="search()" styleClass="p-button-sm"></p-button> -->
        </div>
    </form>
    <app-datatable [dataTable]="datatable" [metadataTable]="metadatatable" [filterGlobal]="true"></app-datatable>
</div>
  <footer>
    <div class="contenido-pie">
        <p></p>
    </div>
  </footer>